import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase.js';

// Who may use Broadcast (owner, 2026-11-02): the people on the Broadcast list
// in the Systems users console (systems.trovex.com/admin/users/apps/eshot,
// stored in platformAccess/eshot). Fails closed: no list, or an open-to-all
// list, lets nobody in but the owner, as Broadcast emails customers.
// The owner and approvers mirror functions/lib/eshot-access.js; the server and
// firestore.rules enforce all of this, this hook only shows the right screens.
export const ESHOT_OWNER = 'arran.north@trovex.com';
export const ESHOT_APPROVERS = ['arran.north@trovex.com', 'regan.cook@trovex.com'];

export function rolesFor(email, accessDoc) {
  const e = String(email || '').toLowerCase().trim();
  if (!e) return { isAdmin: false, isApprover: false, isOwner: false };
  const isOwner = e === ESHOT_OWNER;
  const listed = Array.isArray(accessDoc?.allowedEmails)
    && accessDoc.allowedEmails.some((x) => String(x || '').toLowerCase().trim() === e);
  const isAdmin = isOwner || (e.endsWith('@trovex.com') && listed);
  return { isAdmin, isApprover: isAdmin && ESHOT_APPROVERS.includes(e), isOwner };
}

// isAdmin: may use Broadcast. isApprover: may approve a send to customers.
// isOwner: the switches (sending, sandbox/live, brand, footer, sender).
export function useAdmin(email) {
  const [state, setState] = useState({ email: null, accessDoc: null, loaded: false });
  const key = String(email || '').toLowerCase().trim();
  useEffect(() => {
    if (!key) return undefined;
    return onSnapshot(
      doc(db, 'platformAccess', 'eshot'),
      (snap) => setState({ email: key, accessDoc: snap.exists() ? snap.data() : null, loaded: true }),
      () => setState({ email: key, accessDoc: null, loaded: true }),
    );
  }, [key]);
  if (!key) return { isAdmin: false, isApprover: false, isOwner: false, loading: false };
  const loaded = state.loaded && state.email === key;
  const roles = rolesFor(key, loaded ? state.accessDoc : null);
  // The owner never waits on the list.
  return { ...roles, loading: !loaded && !roles.isOwner };
}
